import React, { Component } from 'react'

const delayRender = ({ timeout } = {}) => ComposedComponent =>
  class Comp extends Component {
    state = { isVisible: false }

    componentDidMount() {
      setTimeout(() => {
        if (!this.stop) {
          this.setState({ isVisible: true })
        }
      }, timeout || 200)
    }

    componentWillUnmount() {
      this.stop = true
    }

    render() {
      if (!this.state.isVisible) {
        return null
      }

      return <ComposedComponent {...this.props} />
    }
  }

export default delayRender
